<template>
  <th :class="thClass" scope="col">
    <v-text-field
      hide-details
      dense
      solo
      clearable
      class="pa-1"
      placeholder="Rechercher"
      :prepend-inner-icon="icon ? 'mdi-magnify' : null"
      :label="labelValue"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </th>
</template>

<script>
import MobileHelper from "@/mixins/MobileHelper";
export default {
  mixins: [MobileHelper],
  props: {
    icon: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  computed: {
    labelValue() {
      if (this.mobile) {
        return this.label;
      }
      return null;
    },
    thClass() {
      if (this.mobile) {
        return "v-data-table__mobile-row";
      }
      return null;
    },
  },
};
</script>
<style scoped>
th {
  background: rgba(0, 0, 0, 0.06);
}
</style>
